
                  export default function (Component) {
                      Component.__source = "src/App.vue"
                  }
              